import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { BackgroundJobs } from '../../../../ts/resources/BackgroundJobs';
import { ICancelBackgroundJobParams } from '../../../../ts/ServerApi/requests/CancelBackgroundJobRequest';
import { ToasterService, ToastType } from '../../../../ts/services/ToasterService';
import { CancelBackgroundJob, OpenCancelBackgroundJobDialog, ToggleBackgroundJobExtendedInfoDialog } from '../../../actions/AppActionTypes';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { CancelBackgroundJobAction } from '../../../actions/spaces/CancelBackgroundJobAction';
import { OpenCancelBackgroundJobDialogAction } from '../../../actions/spaces/OpenCancelBackgroundJobDialogAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ToggleBackgroundJobExtendedInfoDialogAction } from '../../../actions/spaces/ToggleBackgroundJobExtendedInfoDialog';
import { ServiceLocator } from '../../../ServiceLocator';
import { BackgroundJobExtendedInfoDialog } from '../../../spaces/BackgroundJobsSpace/BackgroundJobExtendedInfoDialog';
import { CancelBackgroundJobDialog } from '../../../spaces/BackgroundJobsSpace/CancelBackgroundJobDialog';


export function* openCancelBackgroundJobDialog(action: OpenCancelBackgroundJobDialogAction) {
  try {
    yield call(CancelBackgroundJobDialog.open, action.backgroundJob);
  } catch (e) {
    yield put(requestFailed(e, Messages.backgroundJobCancelFailed()));
  }
}

export async function cancelBackgroundJobAsyncHelper(params: ICancelBackgroundJobParams) {
  const backgroundJobs = ServiceLocator.get<BackgroundJobs>('BackgroundJobs');
  return await backgroundJobs.cancelBackgroundJob(params);
}

export function popToastNotificationForBackgroundJobCancellation(sucessfull: boolean) {
  const service = ServiceLocator.get<ToasterService>('ToasterService');
  if (sucessfull) {
    service.pop({
      text: Messages.backgroundJobCancelSuccessful(),
      type: ToastType.Info,
    });
  } else {
    service.pop({
      text: Messages.backgroundJobCancelFailed(),
      type: ToastType.Error,
    });
  }
}

export function* cancelBackgroundJob(action: CancelBackgroundJobAction) {
  const result = yield call(cancelBackgroundJobAsyncHelper, action.params);
  const errored = result.errors && result.errors.length > 0;
  yield call(popToastNotificationForBackgroundJobCancellation, !errored);
  yield put(requestSpaceContents());
}

export function* toggleBackgroundJobExtendedInfoDialog(action: ToggleBackgroundJobExtendedInfoDialogAction) {
  yield call(BackgroundJobExtendedInfoDialog.toggle, action.backgroundJob);
}

export function* rootBackgroundJobSaga(): SagaIterator {
  yield takeEvery(OpenCancelBackgroundJobDialog, openCancelBackgroundJobDialog);
  yield takeEvery(CancelBackgroundJob, cancelBackgroundJob);
  yield takeEvery(ToggleBackgroundJobExtendedInfoDialog, toggleBackgroundJobExtendedInfoDialog);
}
